/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PamPlayerVerificationStatus = {
    _11184809: '11184809',
    not_started: 'not_started',
    submitted: 'submitted',
    approved: 'approved',
    rejected: 'rejected',
    locked: 'locked',
    denied: 'denied',
    duplicate_review: 'duplicate_review',
    manually_approved: 'manually_approved',
    unknown_default_open_api: '11184809'
} as const;
export type PamPlayerVerificationStatus = typeof PamPlayerVerificationStatus[keyof typeof PamPlayerVerificationStatus];


export function instanceOfPamPlayerVerificationStatus(value: any): boolean {
    for (const key in PamPlayerVerificationStatus) {
        if (Object.prototype.hasOwnProperty.call(PamPlayerVerificationStatus, key)) {
            if (PamPlayerVerificationStatus[key as keyof typeof PamPlayerVerificationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PamPlayerVerificationStatusFromJSON(json: any): PamPlayerVerificationStatus {
    return PamPlayerVerificationStatusFromJSONTyped(json, false);
}

export function PamPlayerVerificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerVerificationStatus {
    return json as PamPlayerVerificationStatus;
}

export function PamPlayerVerificationStatusToJSON(value?: PamPlayerVerificationStatus | null): any {
    return value as any;
}

